import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, useLocation } from 'react-router-dom';

import { isTokenValid } from '../../helpers/token';
import { clearStorage } from '../../helpers/localStorage';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const [authCheckComplete, setAuthCheckComplete] = useState(false);
  const [authCheckPassed, setAuthCheckPassed] = useState(false);
  const location = useLocation();

  useEffect(async () => {
    setAuthCheckPassed(await isTokenValid());
    setAuthCheckComplete(true);
  }, [location]);

  if (!authCheckComplete) {
    return null;
  }

  if (authCheckPassed) {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  }

  clearStorage();
  return <Redirect to="/" />;
};

PrivateRoute.propTypes = {
  component: PropTypes.func
};

export default PrivateRoute;
